import { z } from 'zod';

import { hardSoftSkillWithConfidenceSchema, languageSkillWithConfidenceSchema } from '~/shared/data-contract/skill';

const importedSchema = z.object({
    id: z.uuid(),
    status: z.literal('imported'),
});

const successSchema = z.object({
    id: z.uuid(),
    profile: z.object({
        hardSoftSkills: hardSoftSkillWithConfidenceSchema.array(),
        languages: languageSkillWithConfidenceSchema.array(),
    }),
    status: z.literal('success'),
});

export const cvAnalysisResponseSchema = z.discriminatedUnion('status', [importedSchema, successSchema]);
